<template>
    <div class="search-result__pagination pagination" v-if="totalPages > 1" v-cloak>
        <ul class="search-result__pagination-inner pagination__list">
            <li class="pagination__item pagination__item--prev search-result__previous"
                :class="!previousLink && 'pagination__item--disabled'"
            >
                <a
                    class="pagination__link"
                    v-if="previousLink"
                    :href="previousLink"
                    data-auto-translate="true"
                    @click.prevent="switchPage(-1)">
                    <!-- chevron-left icon -->
                    <
                </a>
                <span
                    v-else
                    class="pagination__link pagination__link--disabled"
                    data-auto-translate="true">
                    <!-- chevron-left icon -->
                    <
                </span>
            </li>

            <li class="pagination__item"
                v-for="(page, idx) in paginationItems"
                :class="page && page.current && 'pagination__item--current'"
                :key="idx"
            >
                <template v-if="page">
                    <span v-if="page.current" class="pagination__current">{{ page.number }}</span>
                    <a v-else class="pagination__link" :href="page.link" @click.prevent="goToPage(page.number)" >
                        {{ page.number }}
                    </a>
                </template>
                <template v-else>
                    <span class="pagination__current">...</span>
                </template>
            </li>

            <li
                class="pagination__item pagination__item--next search-result__next"
                :class="!nextLink && 'pagination__item--disabled'">
                <a
                    class="pagination__link"
                    v-if="nextLink"
                    :href="nextLink"
                    data-auto-translate="true"
                    @click.prevent="switchPage(+1)">
                    <!-- chevron-right icon -->
                    >
                </a>
                <span
                    v-else
                    class="pagination__link pagination__link--disabled"
                    data-auto-translate="true">
                    <!-- chevron-right icon -->
                    >
                </span>
            </li>
        </ul>
    </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {getState, useState} from "../services/stateful";

const props = defineProps({
    results: {
        type: Array,
        required: true
    },
    itemsPerPage: {
        type: Number,
        required: true,
    },
    totalPages: {
        type: Number,
        required: true,
    }
});

const hasPreviousPage = computed(() => currentPage.value > 1);
const hasNextPage = computed(() => currentPage.value < props.totalPages);
const paginationItems = ref([]);
const previousLink = ref(null);
const nextLink = ref(null);

const currentPage = useState('Search.CurrentPage', 1);

function searchPageURL(pageIndex){
    const url = new URL(window.location);
    url.searchParams.set('page', pageIndex);
    return url.toString();
}

function goToPage (pageIndex) {
    currentPage.value = parseInt(pageIndex);

    const url = new URL(window.location);
    url.searchParams.set('page', currentPage.value);
    window.history.pushState({}, '', url);

    const applyFiltering = getState('Search.ApplyFiltering');
    if(applyFiltering.value) {
        applyFiltering.value();
    }
}

function switchPage(step) {
    currentPage.value = currentPage.value + parseInt(step);
    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('page', currentPage.value);
    window.history.pushState({}, '', url);
    // Re-apply filtering and pagination

    const applyFilters = getState('Search.ApplyFiltering');
    if(applyFilters.value) {
        applyFilters.value();
    }
}

const generatePagination = useState('Search.Pagination.Generate', () => {
    paginationItems.value = [];

    if(props.totalPages === 0) {
        return
    }

    const search = new URLSearchParams(window.location.search);

    const currentPage = search.has('page') ? parseInt(search.get('page'), 10) : 1;
    const delta = 2; // Show 2 pages before and after current

    for (let pageIndex = 1; pageIndex <= props.totalPages; pageIndex++) {

        if(pageIndex === 1 || pageIndex === props.totalPages ||
            (pageIndex >= currentPage - delta && pageIndex <= currentPage + delta)) {
            paginationItems.value.push({
                number: pageIndex,
                current: pageIndex === currentPage,
                link: searchPageURL(pageIndex)
            });
        } else if (paginationItems.value[paginationItems.value.length - 1] !== null) {
            paginationItems.value.push(null); // Ellipsis
        }
    }

    generatePaginationLinks();
});

function generatePaginationLinks() {
    if (hasPreviousPage.value) {
        previousLink.value = searchPageURL(currentPage.value - 1);
    } else {
        previousLink.value = null;
    }

    if (hasNextPage.value) {
        nextLink.value = searchPageURL(currentPage.value + 1);
    } else {
        nextLink.value = null;
    }
}

onMounted(() => {
    generatePagination.value();
})
</script>

<style scoped>

</style>
